import institutionAPI from 'services/institutionAPI'
import { SalaryFilters } from 'InstitutionalManagement/types'

type Params = {
  filters: SalaryFilters
}

export default async function readSalariesOnCustomForm({ filters }: Params) {
  const response = await institutionAPI({
    method: 'POST',
    url: '/citizen-portal/service/salaries',
    data: filters,
  })

  return response
}
